import React, { useRef } from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import { useClickable } from '../../hooks/useClickable/useClickable.es.js';
import { Card as Card$1, Header, Content, Footer } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CardComponent = (_a) => {
  var _b = _a, {
    size = "md",
    variant = "solid",
    isError,
    isDisabled,
    isSelected,
    children,
    onClick
  } = _b, props = __objRest(_b, [
    "size",
    "variant",
    "isError",
    "isDisabled",
    "isSelected",
    "children",
    "onClick"
  ]);
  const cardRef = useRef(null);
  const clickableProps = useClickable({ ref: cardRef, isDisabled, onClick, shouldClickOnEnter: true });
  return /* @__PURE__ */ React.createElement(Card$1, __spreadValues(__spreadValues({
    variant,
    size,
    isError,
    "aria-selected": isSelected && !isDisabled
  }, clickableProps), props), children);
};
const Card = maestroComponent("Card", CardComponent, {
  Header: Header,
  Content: Content,
  Footer: Footer
});

export { Card };
//# sourceMappingURL=Card.es.js.map
